import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { ThemeProvider } from 'styled-components';
import { TEMPLATE_THEMES } from '../Theme';
import { PageHead } from '../Layout';
import { RequireFeatureFlag } from '../Auth';
import { LandingPageTemplate } from './LandingPageTemplate';
import { ArticleTemplate } from './ArticleTemplate';
import { TypeformTemplate } from './TypeformTemplate';
import { getTemplateSocialCardUrl } from './socialCard';
import { HelpHomeTemplate } from './Help/HelpHomeTemplate';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export { templateLoader, templateUrlsLoader } from './useTemplate';
export { LandingPageTemplate } from './LandingPageTemplate';
export var TEMPLATE_COMPONENTS = {
  landingPage: LandingPageTemplate,
  videoPage: ArticleTemplate,
  articlePage: ArticleTemplate,
  helpHomePage: HelpHomeTemplate,
  typeformPage: TypeformTemplate
};
export var Template = function Template(_ref) {
  var children = _ref.children,
      template = _objectWithoutProperties(_ref, _excluded);

  var contentType = template.contentType,
      _template$title = template.title,
      title = _template$title === void 0 ? '' : _template$title,
      _template$description = template.description,
      description = _template$description === void 0 ? '' : _template$description,
      _template$theme = template.theme,
      theme = _template$theme === void 0 ? 'Dark' : _template$theme,
      requiredFeatureFlag = template.requiredFeatureFlag,
      canonicalUrl = template.canonicalUrl,
      _template$preview = template.preview,
      preview = _template$preview === void 0 ? false : _template$preview;
  var TemplateComponent = TEMPLATE_COMPONENTS[contentType];

  if (!TemplateComponent) {
    return /*#__PURE__*/_jsxs("span", {
      children: ["Template type \"", contentType, "\" not found"]
    });
  }

  var tplTheme = TEMPLATE_THEMES[theme];

  var templateContent = /*#__PURE__*/_jsxs(ThemeProvider, {
    theme: tplTheme,
    children: [/*#__PURE__*/_jsx(PageHead, {
      title: title,
      description: description,
      image: getTemplateSocialCardUrl(template),
      canonicalUrl: canonicalUrl
    }), /*#__PURE__*/_jsx(TemplateComponent, _objectSpread(_objectSpread({}, template), {}, {
      children: children
    }))]
  });

  if (requiredFeatureFlag && true && !preview) {
    return /*#__PURE__*/_jsx(RequireFeatureFlag, {
      flag: requiredFeatureFlag,
      children: templateContent
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: templateContent
  });
};